export const hasArabic = (s) => /[\u0600-\u06FF]/.test(s || "");
export const hasLatin = (s) => /[A-Za-z]/.test(s || "");
